// =============================================================================
// Phone normalisation + validation for the signup form
// =============================================================================
// React-free on purpose so it can be exercised directly by a test harness.
//
// History, because both rules here were paid for in lost members:
//   • 2026-08-02 — a number written +972-54-… normalised to "97254…", failed the
//     leading-zero test, and silently deadened the submit button. A real user
//     reported it as "the flag button doesn't press".
//   • 2026-08-04 — overseas numbers were rejected outright, turning away Israelis
//     abroad who are supporters and recruiters even where they cannot vote.
// =============================================================================

/**
 * Normalise what the user typed into one of two canonical shapes:
 *   • Israeli local — "0501234567"
 *   • Overseas E.164 — "+14155550123"
 *
 * An overseas number must carry an explicit country code. A bare
 * "14155550123" is ambiguous against a local number, so we require the
 * leading `+` (or `00`, which we rewrite to `+`). A +972/00972 number is
 * Israeli and is folded back to the local 0 form.
 */
export function normalizePhone(raw: string): string {
  const hadPlus = /^\s*(\+|00)/.test(raw)
  let d = raw.replace(/\D/g, "")
  if (d.startsWith("00")) d = d.slice(2)
  if (d.startsWith("972")) return "0" + d.slice(3).replace(/^0+/, "")
  if (hadPlus) return "+" + d
  return d
}

/** Validates the OUTPUT of normalizePhone, not raw user input. */
export function isValidPhone(value: string): boolean {
  if (value.startsWith("+")) return /^\+[1-9]\d{7,14}$/.test(value) // E.164, max 15 digits
  return /^0\d{8,9}$/.test(value)
}
